import { api, ownDancerIdParam } from "../api";

export async function fetchEventBoard(eventId, { dancerId, occurrenceDate }) {
  const r = await api.get(`/events/${eventId}/board`, {
    params: {
      dancer_id: ownDancerIdParam(dancerId),
      occurrence_date: occurrenceDate || undefined,
    },
  });
  return r.data;
}

export async function createBoardMessage(eventId, { dancerId, occurrenceDate, content }) {
  const r = await api.post(`/events/${eventId}/board/messages`, {
    dancer_id: ownDancerIdParam(dancerId),
    occurrence_date: occurrenceDate || undefined,
    content,
  });
  return r.data;
}

export async function deleteBoardMessage(eventId, messageId, { dancerId }) {
  const r = await api.delete(`/events/${eventId}/board/messages/${messageId}`, {
    params: { dancer_id: ownDancerIdParam(dancerId) },
  });
  return r.data;
}

export async function pinBoardMessage(eventId, messageId, { dancerId, isPinned }) {
  const r = await api.patch(`/events/${eventId}/board/messages/${messageId}`, {
    dancer_id: ownDancerIdParam(dancerId),
    is_pinned: isPinned,
  });
  return r.data;
}
